export const DATA_TEST_IDS = {
  helpCenter: 'sidebar-help-center',
  logoRask: 'sidebar-logo-rask',
  questionButton: 'sidebar-question-button',
};
